<template>
  <div class="search-box">
    <input
      placeholder="Search"
      type="input"
      v-model="inputVal"
      v-on:keyup.enter="returnInput(inputVal)"
      class="search-input"
    />

    <button class="clear-button" type="button" id="search-erase-input" tabindex="-1" v-on:click="returnInput('')"></button>

    <div class="search-button" v-on:click="$emit('handleClick')">
      <SearchIcon/>
    </div>
  </div>
</template>


<script>
  import SearchIcon from '../../icons/search.vue'

  export default {
    name: 'Search',
    props: {
      'value': String
    },
    data() {
      return { inputVal: this.value }
    },
    components: {
      SearchIcon
    },
    methods: {
      returnInput(keyword) {
        this.inputVal = keyword
        this.$emit('input', keyword);
        this.$emit('handleClick', keyword)
      }
    },
    watch: {
      inputVal(val) {
        this.$emit('input', val);
      }
    }
  }
</script>